module.exports = __webpack_public_path__ + "static/media/parcel.3d661679.png";